import { ReactNode, memo } from "react";
import { MdExpandMore } from "react-icons/md";

import { SidebarSectionLabelRoot } from "@/layout/styles";

interface SidebarSectionLabelProps {
  id?: string;
  children: ReactNode;
  /**
   * Whether the group under the label is showing. Given together with
   * `onToggle`, the label is the button that folds the group away.
   */
  expanded?: boolean;
  onToggle?: () => void;
  /** The id of the list the label folds. */
  controls?: string;
}

const SidebarSectionLabel = memo(
  ({ id, children, expanded, onToggle, controls }: SidebarSectionLabelProps) => {
    if (!onToggle) {
      return (
        <SidebarSectionLabelRoot id={id} aria-hidden>
          {children}
        </SidebarSectionLabelRoot>
      );
    }

    return (
      <SidebarSectionLabelRoot
        id={id}
        component="button"
        type="button"
        aria-expanded={expanded}
        aria-controls={controls}
        onClick={onToggle}
      >
        {children}
        <MdExpandMore aria-hidden />
      </SidebarSectionLabelRoot>
    );
  },
);
SidebarSectionLabel.displayName = "SidebarSectionLabel";

export default SidebarSectionLabel;
